import { LeakedCodeFilter } from "@gadget-client/keepcart-server";
import * as v from "valibot";

import { LeakedCode } from "../_models/leakedCode";

export const LeakedCodePage = v.object({
  endCursor: v.nullable(v.string()),
  hasNextPage: v.boolean(),
  hasPreviousPage: v.boolean(),
  leakedCodes: v.array(LeakedCode),
  startCursor: v.nullable(v.string()),
});
export type LeakedCodePage = v.InferOutput<typeof LeakedCodePage>;

export interface LeakedCodePageInput {
  after: null | string;
  before: null | string;
  filter: LeakedCodeFilter;
  search: null | string;
}

export const LeakedCodeCounts = v.object({
  active: v.number(),
  couponExtension: v.number(),
  highRisk: v.number(),
  inactive: v.number(),
});
export type LeakedCodeCounts = v.InferOutput<typeof LeakedCodeCounts>;

export interface LeakedCodeReader {
  readonly allExisting: () => Promise<{ leakedCodes: LeakedCode[] }>;
  readonly byId: (id: string) => Promise<LeakedCode>;
  readonly counts: () => Promise<LeakedCodeCounts>;
  readonly page: (input: LeakedCodePageInput) => Promise<LeakedCodePage>;
}
